<template>
  <div id="app">
    <payPage/>
  </div>
</template>

<script>
import payPage from './components/payPage.vue'
export default {
  name: 'App',
  components: {
    payPage,
}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
